import { LIST_GROUP_HEADER_CLASS } from 'utils/surfaceClasses';

// The head of a group of the table, across all its columns: « EN RETARD · 2 ».
// It stays under the table's head (`top`) while its rows scroll by, with its
// line under it; the next group's head then covers it.
// `expanded` undefined: the group does not fold. Otherwise the head is a
// button that folds or unfolds its rows; the count stays shown.
const TaskGroupRow = ({ label, count, columns, top = 0, expanded, onToggle }) => (
  <tr>
    <td
      colSpan={columns}
      style={{ top }}
      className={`${LIST_GROUP_HEADER_CLASS} sticky z-10 border-b border-gray-100`}
    >
      {expanded === undefined ? (
        <>
          {label} · {count}
        </>
      ) : (
        <button type="button" aria-expanded={expanded} onClick={onToggle} className="flex w-full items-center gap-1.5 text-left uppercase">
          <span aria-hidden="true">{expanded ? '▾' : '▸'}</span>
          <span>
            {label} · {count}
          </span>
        </button>
      )}
    </td>
  </tr>
);

export default TaskGroupRow;
